<div ngbDropdown (click)="$event.stopPropagation()">
  <span class="main-menu" ngbDropdownToggle aria-haspopup="true" aria-expanded="false" data-offset="10,10">
    <i class="material-icons">help_outline</i>
    {{compactView?"":"Ayuda"}}
  </span>
  <div class="dropdown-menu dropdown-left" ngbDropdownMenu aria-labelledby="avatar" style="transform: translate(0px, 28px)">
    <button class="dropdown-item" (click)="onHelp($event)">Ayuda</button>
    @if (showTourOption) {
      <button class="dropdown-item" (click)="onTour($event)">Tour Dashboard</button>
    }

    @if (showNoveltyManteinanceOption) {
      <button class="dropdown-item" (click)="onNoveltyMaintenance()">Mantenimiento de<br>Novedades</button>
    }

    @if (showNoveltiesHistoric) {
      <button class="dropdown-item" (click)="openDialogNoveltiesHistoric($event)">Ver
      histórico novedades</button>
    }
  </div>
</div>

<modal-dialog detailDialog #modalNoveltiesHistoric [title]="'Histórico novedades'" cancelText="Cerrar"
  [size]="modalNoveltiesHistoric.dialogSize.Large">
  <loading-overlay [show]="dialogLoading">
    <div class="panel-body panel-collapse">
      <div class="header-table">
        <div class="inner">
          <div class="btn-group">
            <button type="button" class="btn btn-primary">
              <span>Todos los resultados
                @if (novelties) {
                  <span>({{novelties.length}})</span>
                }
              </span>
            </button>
          </div>
        </div>
      </div>

      <!-- Listado -->
      <div class="table-responsive table-sidebar mb-3">
        <table class="table table-randstad table-bordered table-hover">
          <thead>
            @if (novelties && novelties.length > 0) {
              <tr>
              <th class="text-start">
                <div class="hidden-xs order" (click)="orderBy('title')">
                  <span class="order-label">Título Novedad </span>
                  @if (currentFilterParams.properties === 'title' && currentFilterParams.typeOrder === 'ASC') {
                    <i class="material-icons order-asc">arrow_drop_up</i>
                  }
                  @if (currentFilterParams.properties === 'title' && currentFilterParams.typeOrder === 'DESC') {
                    <i class="material-icons order-desc">arrow_drop_down</i>
                  }
                  @if (currentFilterParams.properties !== 'title') {
                    <div class="order-both">
                      <i class="material-icons order-both-asc">arrow_drop_up</i>
                      <i class="material-icons order-both-desc">arrow_drop_down</i>
                    </div>
                  }
                </div>
              </th>
              <th class="text-start">
                <div class="hidden-xs order" (click)="orderBy('begDate')">
                  <span class="order-label">Fecha Inicio </span>
                  @if (currentFilterParams.properties === 'begDate' && currentFilterParams.typeOrder === 'ASC') {
                    <i class="material-icons order-asc">arrow_drop_up</i>
                  }
                  @if (currentFilterParams.properties === 'begDate' && currentFilterParams.typeOrder === 'DESC') {
                    <i class="material-icons order-desc">arrow_drop_down</i>
                  }
                  @if (currentFilterParams.properties !== 'begDate') {
                    <div class="order-both">
                      <i class="material-icons order-both-asc">arrow_drop_up</i>
                      <i class="material-icons order-both-desc">arrow_drop_down</i>
                    </div>
                  }
                </div>
              </th>
              <th class="text-start">
                <div class="hidden-xs order" (click)="orderBy('endDate')">
                  <span class="order-label">Fecha Fin </span>
                  @if (currentFilterParams.properties === 'endDate' && currentFilterParams.typeOrder === 'ASC') {
                    <i class="material-icons order-asc">arrow_drop_up</i>
                  }
                  @if (currentFilterParams.properties === 'endDate' && currentFilterParams.typeOrder === 'DESC') {
                    <i class="material-icons order-desc">arrow_drop_down</i>
                  }
                  @if (currentFilterParams.properties !== 'endDate') {
                    <div class="order-both">
                      <i class="material-icons order-both-asc">arrow_drop_up</i>
                      <i class="material-icons order-both-desc">arrow_drop_down</i>
                    </div>
                  }
                </div>
              </th>
              <th class="text-start">
                <span>Ver vídeo</span>
              </th>
              <th class="text-start">
                <span>Ver fichero</span>
              </th>
            </tr>
            }
          </thead>
          <tbody>
            <ng-container>
              @for (novelty of noveltiesPagination[paginationParams.currentIndex]; track novelty.noveltyId; let i = $index) {
                <tr>
                  <td class="title text-start rand-fixed-column-name">
                    <span>{{ novelty.title}}</span>
                  </td>
                  <td class="title text-start rand-fixed-column-name">
                    <span>{{ novelty.begDate }}</span>
                  </td>
                  <td class="title text-start rand-fixed-column-name">
                    <span>{{ novelty.endDate }}</span>
                  </td>
                  <td class="title text-center rand-fixed-column-name">
                    @if (novelty.url != null) {
                      <a href="{{novelty.url}}" target="_blank" class="text-center"><i
                        class="fa fa-eye"></i></a>
                    }
                  </td>
                  <td class="title text-center rand-fixed-column-name">
                    @if (novelty.attachedName != null) {
                      <a routerLink="" class="text-center"
                        (click)="downloadAttachedName(novelty.noveltyId)">
                        <i class="fa fa-download"></i>
                      </a>
                    }
                  </td>
                </tr>
              }
            </ng-container>

            <!-- Si no hay resultados -->
            @if (!novelties || novelties.length == 0) {
              <tr>
                <td colspan="5" class="text-center">No se encontraron resultados</td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      <!-- Paginación -->
      @if (novelties && novelties.length > 0) {
        <div class="container-pagination">
        <ngb-pagination [collectionSize]="novelties.length" [pageSize]="paginationParams.pageMaxSize"
          [page]="paginationParams.currentPage" [maxSize]="10" [rotate]="true" [ellipses]="true" [boundaryLinks]="true"
          (pageChange)="pagination($event)" class="text-center">
        </ngb-pagination>
      </div>
      }
    </div>

  </loading-overlay>
</modal-dialog>
